import { NavLink } from 'react-router-dom';
import { colors, fonts, spacing } from '../theme';

const navStyle = {
  display: 'flex',
  gap: spacing.sm,
  flexWrap: 'wrap',
  marginBottom: spacing.md,
  padding: spacing.sm,
  backgroundColor: colors.white,
  borderRadius: '12px',
  border: `1px solid ${colors.gray200}`,
};

const linkBase = {
  fontFamily: fonts.heading,
  fontSize: '0.9rem',
  fontWeight: 500,
  textDecoration: 'none',
  padding: `${spacing.sm} ${spacing.md}`,
  borderRadius: '999px',
  color: colors.midGray,
  transition: 'all 0.15s ease',
};

function AdminNav({ pendingCount = 0, unmatchedCount = 0 }) {
  const items = [
    { to: '/admin/matching/incoming', label: unmatchedCount > 0 ? `Incoming (${unmatchedCount})` : 'Incoming' },
    { to: '/admin/matching/unmatched', label: unmatchedCount > 0 ? `Unmatched (${unmatchedCount})` : 'Unmatched' },
    { to: '/admin/matching/people', label: 'People' },
    { to: '/admin/queue', label: pendingCount > 0 ? `Queue (${pendingCount})` : 'Queue' },
    { to: '/admin/clients', label: 'Clients', end: false },
    { to: '/admin/nwra', label: 'NWRA Tools' },
    { to: '/admin/matching/audit', label: 'Audit' },
  ];

  return (
    <nav style={navStyle} aria-label="Admin sections">
      {items.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          end={item.end !== false}
          style={({ isActive }) => ({
            ...linkBase,
            backgroundColor: isActive ? colors.blue : 'transparent',
            color: isActive ? colors.white : colors.midGray,
          })}
        >
          {item.label}
        </NavLink>
      ))}
    </nav>
  );
}

export default AdminNav;
